

































import { Component, Vue } from 'vue-property-decorator';
import WalletCard from '@/components/WalletCard.vue';
import Withdraw from '@/components/Withdraw.vue';
import { WALLET_RECORDS_URL } from '../assets/js/urls';
import utils from '../assets/js/utils';

const axios = require('../axios/index.js').default;

@Component({
  components: {
    WalletCard,
    Withdraw,
  },
})
export default class Home extends Vue {
  tabArr: string[] = ['Records', 'Redeem'];
  tabIdx: number = 0;
  recordList: any[] = [];

  // computed 属性
  get loginStatus(): boolean {
    return this.$store.state.isLogin;
  }

  mounted() {
    this.$as.send('loaded_page_Home');
    this.$bus.$emit('get-config');
    this.getList();
  }

  // 格式化时间
  formatDate(ts: string) {
    return utils.formatDate(ts);
  }

  clickTab(e: any, idx: number) { 
    this.tabIdx = idx;

    this.$as.send('click_tab_' + idx + '_Home');
    if(this.tabIdx === 0) {
      this.getList();
    }
  }

  getWalletValue(record: any) {
    return record.type != 'Withdraw' ? '+' + record.amount : '-' + record.amount;
  }

  getList() {
    let self = this;
    // console.log('self.loginStatus = ', self.loginStatus)
    if(!self.loginStatus) {
      self.$toasted.show("Login first please");
      return;
    }

    self.$bus.$emit('show-loading', true);
    axios.post(WALLET_RECORDS_URL, {})
      .then((resp:any) => {
        // console.log('wallet records: ', resp)
        let data = resp.data;

        self.$bus.$emit('show-loading', false);
        if(data.status.code == 0) {
          self.recordList = data.result.history;
        }else{
          self.recordList = [];
        }
      }).catch((e:any) => {
        self.$toasted.show(e);
        self.$bus.$emit('show-loading', false);
      })
  }
}
